import { Injectable } from "@angular/core";

import { of } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { fetchStampingpartnersListData, fetchStampingpartnersListSuccess, fetchStampingpartnersListFailure, blockStampingpartner, blockStampingpartnerSuccess, blockStampingpartnerFailure, addStampingpartner, addStampingpartnerSuccess, addStampingpartnerFailure, editStampingpartner, editStampingpartnerFailure, editStampingpartnerSuccess, stampingPartnerOnboarding, stampingPartnerOnboardingSuccess, stampingPartnerOnboardingFailure } from "./stampingpartner.actions";
import { AuthenticationService } from "../../core/services/auth.service";
import { ToastifyService } from "../../shared/toastify-service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { StampingpartnerService } from "../../core/services/stampingpartner.service";


@Injectable()
export class StampingpartnerEffects {

  // Stampingpartner
  fetchStampingpartnerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchStampingpartnersListData),
      mergeMap(({isblocked, limit, skip}) =>
        this.restApiService.getStampingpartnersData(isblocked, limit, skip).pipe(
          map((partnerdata) => {
            return fetchStampingpartnersListSuccess({ partnerdata });
          }),
          catchError((error) =>
            of(fetchStampingpartnersListFailure({ error }))
          )
        )
      ),
    ),
  );

  blockStampingpartnerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(blockStampingpartner),
      mergeMap(({ userguid, status }) =>
        this.commonApiService.blockUnblockUser(userguid, status).pipe(
          map(() => blockStampingpartnerSuccess({ userguid: userguid })),
          catchError((error) => of(blockStampingpartnerFailure({ error })))
        )
      )
    )
  );

  blockStampingpartnerDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(blockStampingpartnerSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("Stampingpartner updated successfully.");
        })
      ),
    { dispatch: false }
  );

  blockStampingpartnerDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(blockStampingpartnerFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  addStampingpartnerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addStampingpartner),
      mergeMap(({ name, email, encryptedemail, encryptedname }) =>
        this.restApiService.registerStampingPartner(email, '', name, encryptedemail, encryptedname).pipe(
          map((partner) => addStampingpartnerSuccess({ partner: partner.user })),
          catchError((error) => of(addStampingpartnerFailure({ error })))
        )
      )
    )
  );

  addStampingpartnerDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addStampingpartnerSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("Sent invite successfully.");
        })
      ),
    { dispatch: false }
  );

  addStampingpartnerDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addStampingpartnerFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  editStampingpartnerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editStampingpartner),
      mergeMap(({ guid, data }) =>
        this.restApiService.updateStampingpartnersProfile(guid, data).pipe(
          map((partner) => editStampingpartnerSuccess({ partner: partner })),
          catchError((error) => of(editStampingpartnerFailure({ error })))
        )
      )
    )
  );

  editStampingpartnerDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editStampingpartnerSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("User updated successfully.");
        })
      ),
    { dispatch: false }
  );

  editStampingpartnerDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editStampingpartnerFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Complete Onboarding
  stampingPartnerOnboarding$ = createEffect(() =>
    this.actions$.pipe(
      ofType(stampingPartnerOnboarding),
      exhaustMap(({ company, address, userguid, oprstates, encryptedcompany, encryptedaddress }) => {
        return this.stampingService.onboardingComplete(company, address, userguid, oprstates, encryptedcompany, encryptedaddress).pipe(
          map((user: any) => {
            return stampingPartnerOnboardingSuccess(user);
          }),
          catchError((error) => of(stampingPartnerOnboardingFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  stampingPartnerOnboardingSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(stampingPartnerOnboardingSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Onboarding completed successfully.");
        })
      ),
    { dispatch: false }
  );

  stampingPartnerOnboardingFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(stampingPartnerOnboardingFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private restApiService: StampingpartnerService,
    private commonApiService: CommonAPIService,
    private toastifyService: ToastifyService,
    private stampingService: StampingpartnerService
  ) { }
}